import React, { useState, useEffect } from 'react';
import { Button, Card, CardContent, Checkbox, FormControlLabel, Grid, TextField, Typography } from '@material-ui/core';
import { handleError } from '../../shared/Functions';
import { authProvider } from '../../../services/Security';
import { BillingAccountStatusEnum } from '../../../services/V2/gozer';

export const CustomerDetails = ({ loading, setLoading, billingAccountId, billingAccount, editCustomer, editEnrollment, editBillingAccount, style }) => {
    const [formData, setFormData] = useState<any>();
    const [customerId, setCustomerId] = useState<any>();
    const [canEditBillingAccount, setCanEditBillingAccount] = useState<boolean>(false);
    const [editMode, setEditMode] = useState<boolean>(false);

    useEffect(() => {
        setFormData(billingAccount)
        setCustomerId(billingAccount.customer.id)
    }, [billingAccount])

    useEffect(() => {
        let perms = authProvider.getPermissions();
        setCanEditBillingAccount(perms.some((perm: string) => perm === "UpdateBillingAccounts"));
    }, [])

    const handleChange = event => {
        let name = event.target.name;
        let value = event.target.value;
        if (event.target.type === "checkbox") {
            value = event.target.checked;
        }
        setFormData({
            ...formData,
            [name]: value
        })
    }

    const handleChangeNested = (event, nestedName)=> {
        if(!formData) return;
        let name = event.target.name;
        let value = event.target.value === "" ? null : event.target.value;

        if (event.target.type === "checkbox") {
            value = event.target.checked
        }
        setFormData({
            ...formData,
            [nestedName]: {
                ...formData[nestedName],
                [name]: value
            }
        })
    }

    const handleCancel = () => {
        setFormData(billingAccount);
        setEditMode(false);
    }

    const handleEdit = async event => {
        event.preventDefault();

        let editModel = formData.customer;
        let editEnrollmentModel = formData.enrollment;
        
        editCustomer(billingAccountId, customerId, editModel)
            .then(() => setLoading(!loading))
            .catch(err => handleError(err));
        editEnrollment(billingAccountId, editEnrollmentModel)
            .then(() => setLoading(!loading))
            .catch(err => handleError(err));
        handleCancel();
    };

    const handleActive = () => {
        let confirm = window.confirm("Are you sure you want to do this?");

        if (confirm === true) {
            let newActiveState = formData.isActive ? false : true;

            editBillingAccount(billingAccountId, { ...formData, isActive: newActiveState })
                .then(() => setLoading(!loading))
                .catch(err => handleError(err));
            handleCancel();
        }
    }

    if(!formData) return null;

    return (
        <Card raised={false} style={style}>
            <CardContent>
                <div className="row col-12">
                    <Grid item xs={5}
                        container={true}
                        alignContent="flex-start">
                        <b>District:</b>&nbsp;{billingAccount.districtInfo?.name}
                    </Grid>
                    <Grid item xs={4}
                        container={true}
                        alignContent="flex-start">
                        {editMode ?
                            <TextField
                                style={{margin: "0px"}}
                                onChange={handleChange}
                                margin="normal"
                                name="accountNumber"
                                label="Account Number"
                                type="text"
                                value={formData === undefined ? null : formData.accountNumber}
                            /> :
                            <><b>Account Number:</b>&nbsp;{billingAccount.accountNumber}</>
                        }
                    </Grid>
                    <Grid item xs={3}
                        container={true}
                        alignContent="flex-start">
                        {editMode ?
                            <TextField style={{ width: '100%', textAlign: 'left', margin: "0px" }}
                                select
                                onChange={handleChange}
                                margin="normal"
                                name="status"
                                label="Status"
                                type="string"
                                defaultValue={formData === undefined || formData.status === undefined ? "" : formData.status}
                            >
                                {Object.keys(BillingAccountStatusEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                    return <option key={r} value={BillingAccountStatusEnum[r]}>
                                            {BillingAccountStatusEnum[r]}
                                        </option>
                                })}
                            </TextField> :
                            <><b>Status:</b>&nbsp;{billingAccount.status}</>
                        }
                    </Grid>
                </div>
                <Typography variant="h5" component="h2" style={{textAlign:"left"}}>Customer Details</Typography>
                <div className="row col-12">
                    <Grid item xs={6}
                        container={true}
                        alignContent="flex-start">
                        <TextField
                            disabled={!editMode}
                            style={{margin: "0px"}}
                            onChange={e => handleChangeNested(e, 'customer')}
                            required={false}
                            margin="normal"
                            name="firstName"
                            label="First Name"
                            type="text"
                            value={formData === undefined ? null : formData.customer?.firstName}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}
                        container={true}
                        alignContent="flex-start"
                        style={{paddingLeft: "50px", margin: "0px"}}>
                        <TextField
                            disabled={!editMode}
                            style={{margin: "0px"}}
                            onChange={e => handleChangeNested(e, 'customer')}
                            required={false}
                            margin="normal"
                            name="lastName"
                            label="Last Name"
                            type="text"
                            value={formData === undefined ? null : formData.customer?.lastName}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}
                        container={true}
                        alignContent="flex-start">
                        <TextField
                            disabled={!editMode}
                            style={{margin: "0px"}}
                            onChange={e => handleChangeNested(e, 'customer')}
                            required={false}
                            margin="normal"
                            name="street"
                            label="Street"
                            type="text"
                            value={formData === undefined ? null : formData.customer?.street}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}
                        container={true}
                        alignContent="flex-start"
                        style={{paddingLeft: "50px"}}>
                        <TextField
                            disabled={!editMode}
                            style={{margin: "0px"}}
                            onChange={e => handleChangeNested(e, 'customer')}
                            required={false}
                            margin="normal"
                            name="city"
                            label="City"
                            type="text"
                            value={formData === undefined ? null : formData.customer?.city}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={3}
                        container={true}
                        alignContent="flex-start">
                        <TextField
                            disabled={!editMode}
                            style={{margin: "0px"}}
                            onChange={e => handleChangeNested(e, 'customer')}
                            required={false}
                            margin="normal"
                            name="state"
                            label="State"
                            type="text"
                            value={formData === undefined ? null : formData.customer?.state}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={3}
                        container={true}
                        alignContent="flex-start"
                        style={{paddingLeft: "50px"}}>
                        <TextField
                            disabled={!editMode}
                            style={{margin: "0px"}}
                            onChange={e => handleChangeNested(e, 'customer')}
                            required={false}
                            margin="normal"
                            name="zip"
                            label="Zip"
                            type="text"
                            value={formData === undefined ? null : formData.customer?.zip}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={3}
                        container={true}
                        alignContent="flex-start"
                        style={{paddingLeft: "50px"}}>
                        <TextField
                            disabled={!editMode}
                            style={{margin: "0px"}}
                            onChange={e => handleChangeNested(e, 'customer')}
                            required={false}
                            margin="normal"
                            name="zip4"
                            label="Zip + 4"
                            type="text"
                            value={formData === undefined ? null : formData.customer?.zip4}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={3} />
                    <Grid item xs={6}
                        container={true}
                        alignContent="flex-start">
                        <TextField
                            disabled={!editMode}
                            style={{margin: "0px"}}
                            onChange={e => handleChangeNested(e, 'customer')}
                            required={false}
                            margin="normal"
                            name="email"
                            label="Email"
                            type="text"
                            value={formData === undefined ? null : formData.customer?.email}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}
                        container={true}
                        alignContent="flex-start"
                        style={{paddingLeft: "50px"}}>
                        <TextField
                            disabled={!editMode}
                            style={{margin: "0px"}}
                            onChange={e => handleChangeNested(e, 'customer')}
                            required={false}
                            margin="normal"
                            name="homePhone"
                            label="Home Phone"
                            type="text"
                            value={formData === undefined ? null : formData.customer?.homePhone}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}
                        container={true}
                        alignContent="flex-start">
                        <TextField
                            disabled={!editMode}
                            style={{margin: "0px"}}
                            onChange={e => handleChangeNested(e, 'customer')}
                            required={false}
                            margin="normal"
                            name="cellPhone"
                            label="Cell Phone"
                            type="text"
                            value={formData === undefined ? null : formData.customer?.cellPhone}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}
                        container={true}
                        alignContent="flex-start"
                        style={{paddingLeft: "50px"}}>
                        <TextField
                            disabled={!editMode}
                            style={{margin: "0px"}}
                            onChange={e => handleChangeNested(e, 'customer')}
                            required={false}
                            margin="normal"
                            name="workPhone"
                            label="Work Phone"
                            type="text"
                            value={formData === undefined ? null : formData.customer?.workPhone}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={3}
                        container={true}
                        alignContent="flex-start">
                        <FormControlLabel style={{ margin:'0px' }}
                            label="Paperless Billing"
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    disabled={!editMode}
                                    checked={(formData === undefined
                                        || formData === null || formData.enrollment?.paperBill === undefined ? false : !formData.enrollment?.paperBill)}
                                    onChange={e => handleChangeNested(e, 'enrollment')}
                                    color="primary"
                                    name="paperBill" />
                        } />
                    </Grid>
                    <Grid item xs={3}
                        container={true}
                        alignContent="flex-start">
                        <FormControlLabel style={{ margin:'0px' }}
                            label="Disallow CC"
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    disabled={!editMode}
                                    checked={(formData === undefined
                                        || formData === null || formData.disallowCCPayments === undefined ? false : formData.disallowCCPayments)}
                                    onChange={handleChange}
                                    color="primary"
                                    name="disallowCCPayments" />
                        } />
                    </Grid>
                    <Grid item xs={3}
                        container={true}
                        alignContent="flex-start">
                        <FormControlLabel style={{ margin:'0px' }}
                            label="Disallow ACH"
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    disabled={!editMode}
                                    checked={(formData === undefined
                                        || formData === null || formData.disallowACHPayments === undefined ? false : formData.disallowACHPayments)}
                                    onChange={handleChange}
                                    color="primary"
                                    name="disallowACHPayments" />
                        } />
                    </Grid>
                    <Grid item xs={12}
                        container={true}
                        alignContent="flex-start">
                        <Button
                            hidden={!editMode}
                            onClick={handleCancel}>
                            Cancel
                        </Button>
                        <Button
                            hidden={!editMode}
                            onClick={handleActive}
                            color="secondary">
                            {formData.isActive ? "Deactivate" : "Activate"}
                        </Button>
                        <Button
                            hidden={!editMode}
                            onClick={handleEdit}
                            color="primary">
                            Save
                        </Button>
                        <Button
                            disabled={!canEditBillingAccount}
                            hidden={editMode}
                            onClick={() => setEditMode(true)}
                            color="primary">
                            Edit
                        </Button>
                    </Grid>
                </div>
            </CardContent>
        </Card>
    );
}